import { G, GL, GB, BLACK, MID, LIGHT, BORDER, BG } from "../constants";
import { Ring, SevBadge } from "../components/shared";
import { PageHead, Footer } from "../components/Shell";

export function S04({ sel, fixes, setFixes, onBack, onNext, products }) {
  const prods = products.filter(p => sel.includes(p.id));
  const total = prods.reduce((s, p) => s + p.gmcIssues.length, 0);
  const fixed = Object.values(fixes).filter(Boolean).length;

  const applyAll = pid => {
    const p = products.find(x => x.id === pid);
    const next = { ...fixes };
    p.gmcIssues.forEach(i => { next[`${pid}-${i.field}`] = true; });
    setFixes(next);
  };

  const applyAllProducts = () => {
    const next = { ...fixes };
    prods.forEach(p => p.gmcIssues.forEach(i => { next[`${p.id}-${i.field}`] = true; }));
    setFixes(next);
  };

  const allFixed = fixed === total && total > 0;

  return (
    <>
      <PageHead num="06" title="GMC Fix" sub="Live feed health pulled from Merchant Centre. AI-proposed fixes - review before applying." onBack={onBack} onNext={onNext} nextLabel="Optimise Product Feed →" />

      {/* Optional notice */}
      <div style={{ marginBottom: 16, padding: "10px 16px", background: "#fffbeb", border: `1px solid #fde68a`, borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 16 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span style={{ fontSize: 11, fontWeight: 800, color: "#92400e", background: "#fef3c7", border: `1px solid #fde68a`, padding: "2px 8px", borderRadius: 4, textTransform: "uppercase", letterSpacing: "0.4px" }}>Optional</span>
          <span style={{ fontSize: 12, color: "#92400e" }}>GMC Fix only applies if you have Google Merchant Centre connected. You can skip this and go straight to copy optimisation.</span>
        </div>
        <button onClick={onNext} style={{ background: "#fff", color: "#92400e", border: `1px solid #fde68a`, borderRadius: 6, padding: "6px 14px", fontSize: 12, fontWeight: 700, cursor: "pointer", fontFamily: "inherit", whiteSpace: "nowrap" }}>
          Skip - Optimise Copy →
        </button>
      </div>

      {/* Apply all bar */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16, padding: "10px 16px", background: "#fafafa", border: `1px solid ${BORDER}`, borderRadius: 8 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <button onClick={applyAllProducts} disabled={allFixed}
            style={{ background: allFixed ? BG : BLACK, color: allFixed ? G : "#fff", border: `1px solid ${allFixed ? GB : BLACK}`, borderRadius: 6, padding: "8px 18px", fontSize: 13, fontWeight: 700, cursor: allFixed ? "default" : "pointer", fontFamily: "inherit" }}>
            {allFixed ? "✓ All fixes applied" : `Apply all fixes (${total})`}
          </button>
          <span style={{ fontSize: 12, color: LIGHT }}>{fixed} of {total} applied across {prods.length} SKU{prods.length !== 1 ? "s" : ""}</span>
        </div>
        <button onClick={onNext}
          style={{ background: G, color: "#fff", border: "none", borderRadius: 6, padding: "8px 20px", fontSize: 13, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>
          Optimise Product Feed →
        </button>
      </div>

      {/* Summary */}
      <div style={{ display: "flex", border: `1px solid ${BORDER}`, borderRadius: 8, overflow: "hidden", marginBottom: 22 }}>
        {[{ l: "Total issues", v: total, c: BLACK }, { l: "Fixed", v: fixed, c: G }, { l: "Remaining", v: total - fixed, c: total - fixed > 0 ? "#d97706" : G }].map((x, i) => (
          <div key={x.l} style={{ flex: 1, padding: "13px 18px", borderRight: i < 2 ? `1px solid ${BORDER}` : "none", background: "#fafafa" }}>
            <div style={{ fontSize: 18, fontWeight: 700, color: x.c }}>{x.v}</div>
            <div style={{ fontSize: 11, color: LIGHT, marginTop: 2, textTransform: "uppercase", letterSpacing: "0.4px", fontWeight: 600 }}>{x.l}</div>
          </div>
        ))}
      </div>

      {prods.map(p => {
        const fc = p.gmcIssues.filter(i => fixes[`${p.id}-${i.field}`]).length;
        const ns = Math.round(p.feedScore + (p.impact.scoreAfter - p.feedScore) * (fc / p.gmcIssues.length));
        return (
          <div key={p.id} style={{ border: `1px solid ${BORDER}`, borderRadius: 8, overflow: "hidden", marginBottom: 14 }}>
            <div style={{ padding: "12px 16px", borderBottom: `1px solid ${BORDER}`, background: "#fafafa", display: "flex", alignItems: "center", gap: 12 }}>
              <div style={{ flex: 1 }}>
                <span style={{ fontWeight: 700, fontSize: 13 }}>{p.title}</span>
                <span style={{ fontSize: 11, color: LIGHT, marginLeft: 8 }}>{p.sku}</span>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <Ring score={p.feedScore} size={38} />
                <span style={{ fontSize: 11, color: LIGHT }}>→</span>
                <Ring score={ns} size={38} />
              </div>
              <button onClick={() => applyAll(p.id)} style={{ background: G, color: "#fff", border: "none", borderRadius: 6, padding: "6px 13px", fontSize: 12, fontWeight: 600, cursor: "pointer", fontFamily: "inherit" }}>Apply all</button>
            </div>

            {p.gmcIssues.map((issue, i) => {
              const done = fixes[`${p.id}-${issue.field}`];
              return (
                <div key={issue.field} style={{ display: "flex", alignItems: "center", gap: 12, padding: "11px 16px", borderBottom: i < p.gmcIssues.length - 1 ? `1px solid ${BORDER}` : "none", background: done ? GL : BG }}>
                  <div style={{ width: 7, height: 7, borderRadius: "50%", background: done ? G : issue.sev === "high" ? "#dc2626" : "#d97706", flexShrink: 0 }} />
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 13, fontWeight: 600, display: "flex", gap: 7, alignItems: "center" }}>
                      <span style={{ color: done ? G : BLACK }}>{issue.type}: <code style={{ background: "#f3f4f6", padding: "1px 5px", borderRadius: 3, fontSize: 11 }}>{issue.field}</code></span>
                      <SevBadge level={issue.sev} />
                    </div>
                    <div style={{ fontSize: 11, color: LIGHT, marginTop: 2 }}>{issue.why}</div>
                  </div>
                  <div style={{ fontSize: 12, color: done ? G : MID, background: done ? GL : "#f9fafb", border: `1px solid ${done ? GB : BORDER}`, padding: "4px 9px", borderRadius: 5, fontWeight: 600, maxWidth: 260, textAlign: "right", flexShrink: 0 }}>
                    {done ? `✓ ${issue.fix}` : issue.fix}
                  </div>
                  {!done && (
                    <button onClick={() => setFixes({ ...fixes, [`${p.id}-${issue.field}`]: true })}
                      style={{ background: BLACK, color: "#fff", border: "none", borderRadius: 5, padding: "5px 11px", fontSize: 12, fontWeight: 600, cursor: "pointer", fontFamily: "inherit", flexShrink: 0 }}>
                      Apply
                    </button>
                  )}
                </div>
              );
            })}
          </div>
        );
      })}
      <Footer onBack={onBack} onNext={onNext} nextLabel="Optimise Product Feed →" />
    </>
  );
}

// ─── PREVIEW PANELS ──────────────────────────────────────────────────────────


